<div class="format-date">
  <span>{{ getFormatedDate() }}</span>
  <div
    inlineSVG="/assets/icons/calander-picker.svg"
    (click)="togglePickers()"
    *ngIf="allowEdit"
    class="toggle-pickers"
  ></div>
</div>

<div
  *ngIf="showPickers"
  outsideClick
  (outsideClick)="onClickOutside($event)"
  class="pickers"
>
  <datepicker
    [(date)]="jsDate"
    (dateChange)="onDateChanged($event)"
    (onEscape)="closePickers()"
  ></datepicker>
  <evrideo-separate-time-picker
    [(time)]="internalDate"
    (timeChange)="onTimeChanged($event)"
  >
  </evrideo-separate-time-picker>
</div>
